import { useState, useEffect } from "react";
import { Button, Box, TextField, Avatar } from "@mui/material";
import { UseWalletManage } from "./UseWalletManage";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { useRecoilState } from "recoil";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { removeComma, toMoney } from "../../util/Utils";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditWalletOffer() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const { validate, geOfferById, EditOffer } = UseWalletManage();
  const [imgState, setImgState] = useState({
    file: undefined,
    url: undefined,
  });
  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    cost1: 0,
    cost2: 0,
  });
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    cost1: false,
    file: false,
    title: false,
  });

  const handleChangeImage = (e) => {
    setImgState({
      ...imgState,
      file: e.target.files[0],
      url: URL.createObjectURL(e.target.files[0]),
    });
  };

  useEffect(() => {
    if (location.state && location.state.id) {
      geOfferById(location.state.id, (callback) => {
        setImgState({ ...imgState, url: callback.image });
        setState({
          id: callback.id,
          title: callback.title ? callback.title : "",
          cost1: callback.cost1 ? callback.cost1 : 0,
          cost2: callback.cost2 ? callback.cost2 : 0,
        });
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/walletManagment" },
          { name: "ویرایش آفر", url: "/walletManagment/editWalletOffer" },
        ],
      }}
    >
      <Box display="grid" gap={3}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ کارت"
              error={errorState.cost1}
              size="small"
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={state.cost1 ? toMoney(state.cost1) : ""}
              onChange={(evt) => {
                setState({
                  ...state,
                  cost1: removeComma(evt.target.value),
                });
              }}
              variant="outlined"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="مبلغ هدیه"
              size="small"
              sx={{
                input: {
                  direction: "rtl",
                },
              }}
              value={state.cost2 ? toMoney(state.cost2) : ""}
              onChange={(evt) => {
                setState({
                  ...state,
                  cost2: removeComma(evt.target.value),
                });
              }}
              variant="outlined"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 5"} component="label">
            <Avatar
              sx={{
                border: "1px solid #d9d9d9",
                borderRadius: 3,
                width: "200px",
                height: "100%",
                p: 1,
              }}
              src={imgState.url ? imgState.url : "/static/img/nobanner.jpg"}
              alt="img"
            />
            <input
              type="file"
              id="img"
              name="avatarName"
              accept="image/*"
              multiple
              onChange={handleChangeImage}
              hidden
            />
          </Box>
          {!isSmall && <Box gridColumn="span 7"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "70px" }}
              variant="contained"
              onClick={() => {
                if (validate(state, imgState, setErrorState, true) == 200) {
                  setProgress(true);
                  EditOffer(state, imgState.file, () => {
                    navigate("/walletManagment", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "70px" }}
              variant="outlined"
              onClick={() => {
                navigate("/walletManagment", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
        </Box>
      </Box>
    </Detail>
  );
}
